<template lang="pug">
.v-news.news(v-if="news")
	v-loader(:loading="loading")
	.news__container.container
		v-title.news__main-title(v-if="news.mainTitle" :title="news.mainTitle")
		template(v-if="mode === 'catalog'" )
			.catalog__filter-tags(v-if="news.field")
				v-filter.news__filter(ref="filterTags"
						:filters="news.field"
						@filter-changed="filterChanged"
						:view="news.type")
			.news__catalog-wrap
				template(v-for="(item, itemIndex) in news.items.slice(0, 28)" :key="itemIndex")
					a.blogs__card-wrapper(:href="item.link")
						img.blogs__card-img(:src="item.image" alt="" loading="lazy")
						.blogs__card-text(v-if="item.text") {{item.text}}
						.blogs__card-date(v-if="item.date") {{item.date}}
				template(v-if="news.items && news.items.length")
					.catalog__nav.flc
						v-page-nav(:page="news.page" @navigate="navigate")
		template(v-else)
			.news__main-wrap
				.news__wrap
					.news__title(v-if="news.title") {{news.title}}
					.news__items-container(v-if="news.items && news.items.length")
						template(v-for="(item, itemIndex) in getVisibleItems()" :key="itemIndex")
							a.blogs__card-wrapper(:href="item.link")
								img.blogs__card-img(:src="item.image" alt="" loading="lazy")
								.blogs__card-text(v-if="item.text") {{item.text}}
								.blogs__card-date(v-if="item.date") {{item.date}}
					a.news__btn(v-if="news.btn"
							:href="news.btn.link"
							:class="news.btn.className || ''")
						| {{news.btn.text}}
				.news__sidebar(v-if="news.sidebar")
					.news__sidebar-wrapper
						.news__sidebar-top
							img.news__sidebar-image(v-if="news.sidebar.image" :src="news.sidebar.image" alt="" loading="lazy")
							.news__sidebar-text(v-if="news.sidebar.text") {{news.sidebar.text}}
							.news__sidebar-information(v-if="news.sidebar.information")
								.news__information-item(v-if="news.sidebar.information.length"
										v-for="(item, itemIndex) in news.sidebar.information"
										:key="itemIndex")
									.news__information-count(v-if="item.countText") {{item.countText}}
									.news__information-countnews__information.news__information-count--text(v-if="item.text") {{item.text}}
							.news__btn-wrapper
								a.news__sidebar-btn(v-if="news.sidebar.btn"
										:class="news.sidebar.btn.className || ''"
										:href="news.sidebar.btn.link"
										target="_blank")
									| {{news.sidebar.btn.text}}
						a.news__sidebar-bottom(v-if="news.sidebar.bottomLink"
								:href="news.sidebar.bottomLink.link"
								target="_blank")
							img.news__bottom-img(:src="news.sidebar.bottomLink.icon" alt="" loading="lazy")
							.news__bottom-wrapper
								.news__bottom-text(v-if="news.sidebar.bottomLink.text") {{news.sidebar.bottomLink.text}}
								.news__bottom-address(v-if="news.sidebar.bottomLink.address") {{news.sidebar.bottomLink.address}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	props: {
		mode: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			news: null,
			page: null,
			tag: null
		};
	},

	methods: {
		dataSet(data) {
			this.news = data;
			if (this.news.page) {
				this.page = this.news.page;
			}
			this.$nextTick(() => {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			});
		},

		navigate(page) {
			this.page.offset = page.offset;
			this.page.limit = page.limit;
			this.requestDataLoad({append: page.append});
		},

		getVisibleItems() {
			return this.news.items.slice(0, this.news.sidebar ? 3 : 4);
		},

		filterChanged(filterValue, autosubmit) {
			if (this.news.field[0].value === filterValue.TAGS.value) {
				this.tag = {};
			} else {
				this.tag = filterValue;
			}
			if (autosubmit) {
				this.requestDataLoad({});
			}
		},

		requestDataLoad(dataSetOptions) {
			if (this.news) {
				this.dataLoad({
					url: this.news.remote,
					delay: true,
					data: {
						page: this.page,
						tag: this.tag
					}
				}, dataSetOptions);
			}
		}
	}
};
</script>